import { get } from "lodash";

export const meals = state => state.catering.checkin.meals.meals;
export const fetching = state => state.catering.checkin.meals.fetching;
